import { render, staticRenderFns } from "./DomainListItem.vue?vue&type=template&id=1047ddb7&"
import script from "./DomainListItem.vue?vue&type=script&lang=js&"
export * from "./DomainListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports